export const useNormalizedColors = (): Record<
  string,
  { value: string; it: string; en: string }
> => ({
  black: { value: "#2D2D2D", it: "Nero", en: "Black" },
  brown: { value: "#9A7352", it: "Marrone", en: "Brown" },
  beige: { value: "#CDBD9A", it: "Beige", en: "Beige" },
  grey: { value: "#BEBEBE", it: "Grigio", en: "Grey" },
  gray: { value: "#BEBEBE", it: "Grigio", en: "Gray" },
  white: { value: "#FFFFFF", it: "Bianco", en: "White" },
  blue: { value: "#214377", it: "Blu", en: "Blue" },
  "light-blue": { value: "#badbff", it: "Azzurro", en: "Light blue" },
  green: { value: "#55A860", it: "Verde", en: "Green" },
  yellow: { value: "#FFD400", it: "Giallo", en: "Yellow" },
  orange: { value: "#DF4E29", it: "Arancione", en: "Orange" },
  red: { value: "#DC343B", it: "Rosso", en: "Red" },
  pink: { value: "#ED7A9E", it: "Rosa", en: "Pink" },
  violet: { value: "#764C82", it: "Viola", en: "Violet" },
  purple: { value: "#cc99ff", it: "Lilla", en: "Purple" },
  gold: { value: "#F7BF68", it: "Oro", en: "Gold" },
  silver: { value: "#D6D5C6", it: "Argento", en: "Silver" },
  multicolor: { value: "#FFFFFF", it: "Multicolore", en: "Multicolor" },
});
